export default __webpack_public_path__ + "static/media/clear-day.9abac4b0.svg";